import React, { useEffect,useState } from 'react';
import IsLoadingBar from './isLoading';
import { useMsal } from "../Auth/msal-context";
import { useLocation } from "react-router-dom";

import confusedDog from "../images/10607-dog-avatar-confused.png"
import dog from "../images/10607-dog-avatar.png"

const AccessRequest = (props) => {
    const { getToken } = useMsal();
    const [isLoading, setIsLoading] = useState(true);    
    const [approveMsg, setApproveMsg] = useState(false);
    const [errorMsg, setErrorMsg ] = useState("");

    let location = useLocation();

    useEffect(() => {        
        const urlParams = new URLSearchParams(location.search);
        const requestId = urlParams.get('id');
        if(requestId){
            approveRequest(requestId);
        }
        
        setIsLoading(false);
    },[]);

    const approveRequest = async (requestId) => {
        let accessToken = await getToken();

        fetch(`/api/ApproveSecondaryAccess`, {
            method : "POST",
            headers: {
                'Content-Type' : 'application/json',
                'Authorization': "Bearer " + accessToken
            },
            body : JSON.stringify( { RequestID : requestId })
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => { 
            let output = data.output;
            if(output){
                if(output.Output.indexOf("Error:") > -1){
                    setApproveMsg(false);
                    setErrorMsg(output.Output);
                    return; 
                }
                setApproveMsg(true);                          
            }            
        }).catch((error) => {
            window.apiError(error);
        });
    };


    if(isLoading){
        return  <IsLoadingBar />;
    }

    return (
        <div className="d-flex vh-100 overflow-hidden" style={{ color: "grey"}}>
            <div className="m-auto">
                {approveMsg ?
                    <>
                        <img src={dog} alt="fetch logo" />
                        <h4 className="mt-3">Secondary access has been granted to the requesting user</h4>
                        <p className="mt-3">You can now close this screen.</p>
                    </>
                :
                    <>
                        <img src={confusedDog} alt="fetch logo" />
                        <h4 className="mt-3">{errorMsg}</h4>
                    </>
                }
            </div>
            

        </div>
   );

}

export default AccessRequest;
